import { useContext, useEffect } from "react";

import { FiltersContext } from "./context";

export const useFilters = () => {
  const context = useContext(FiltersContext);

  if (!context) {
    throw new Error("useFilters can only be used inside FiltersProvider");
  }

  return context;
};

export const useBlockNavigation = ({
  blockNavigation,
  onBlock,
}: {
  blockNavigation: boolean;
  onBlock: (blockedUrl: string) => void;
}) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (event.target instanceof Element) {
        const link = event.target.closest("a");

        if (link && link.target !== "_blank" && blockNavigation) {
          event.preventDefault();
          event.stopPropagation();

          const href = link.attributes.getNamedItem("href");

          if (href) {
            onBlock(href.value);
          }
        }
      }
    };

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (blockNavigation) {
        event.preventDefault();
      }
    };

    window.addEventListener("click", handleClick, true);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("click", handleClick, true);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [blockNavigation]);
};
